import React from 'react';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { useTranslation } from 'react-i18next';
import { MenuInfoButton } from './MenuInfoButton';

interface MenuAllergenButtonProps {
    link: string;
    desktop?: boolean;
    onClick?: () => void;
}

export const MenuAllergenButton: React.FC<MenuAllergenButtonProps> = ({ link, onClick, desktop = false }) => {
    const { t } = useTranslation();
    return (
        <a href={link} target="_blank" rel="noopener noreferrer" onClick={onClick}>
            <MenuInfoButton desktop={desktop} variant="outlined" endIcon={<InfoOutlineIcon />}>
                {t('MENU_ALLERGENS_BUTTON')}
            </MenuInfoButton>
        </a>
    );
};
